import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'common-gis-export',
  templateUrl: './gis-export.component.html',
  styleUrls: ['./gis-export.component.scss'],
  standalone: false,
})
export class GisExportComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
